import { Injectable } from '@angular/core';

import { TipoUrlEnum } from '../utilidades.index';
import { UtilidadesService } from '../utilidades.servicios.index';

import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class TiposDeDocumentosService {

	constructor(
		private Utilidades: UtilidadesService
	) { }

	public Lista(): Observable<any> {
		return this.Utilidades.Get("WebServices/Tributos/General/TiposDeDocumentos", TipoUrlEnum.Externa);
	}

	public Obtener(subcodigo: number): Observable<any> {
		return this.Utilidades.Get("WebServices/Tributos/General/TiposDeDocumentos/Obtener/" + subcodigo, TipoUrlEnum.Externa);
	}
}